import { Work } from "@/javascript/domain/entities/work"

const disabledWorkText = (work: Work) => {
  if (!work.resourcePlace) return 'Atividade não possui Cliente ou Local selecionado'
  const invalidAddress = !work.resourcePlace.latitude?.toString() || !work.resourcePlace.longitude?.toString() || !work.resourcePlace.address?.toString()
  if (invalidAddress) return 'Atividade não possui endereço cadastrado'
}

export default disabledWorkText
